import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Box from '@ntuctech/devex-tangram/Box';
import Typography from '@ntuctech/devex-tangram/Typography';
import ButtonIcon from '@ntuctech/devex-tangram/Button/ButtonIcon';
import SvgArrowLeft from '@ntuctech/devex-tangram/Icon/SvgArrowLeft';

const StyledBox = styled(Box)`
  position: relative;
`;

const PageHeaderSC = styled.header`
  text-align: center;
`;

const StyledButtonIcon = styled(ButtonIcon)`
  position: absolute;
  top: -0.25rem;
  left: -0.25rem;
`;

const PageHeader = ({ header, spacing: spacingProp, backAction }) => {
  const defaultSpacing = { mb: 1.5 };
  const spacing = { ...defaultSpacing, ...spacingProp };
  const htmlHeader = `${header} - Linkpass`; // TODO: change to Linkpass after 1 Apr

  return (
    <StyledBox {...spacing}>
      {backAction && (
        <StyledButtonIcon
          className="ndsHidden-m-up"
          compact
          size="l"
          onClick={backAction}
          data-testid="goBackButton"
        >
          <SvgArrowLeft color="#1454b8" />
        </StyledButtonIcon>
      )}

      <PageHeaderSC
        data-testid="pageHeader"
        className={`SSOPage__header${backAction ? ' SSOPage__header-with-action' : ''}`}
      >
        <Typography variant="h3" as="h1">
          {header}
        </Typography>
        <title>{htmlHeader}</title>
      </PageHeaderSC>
    </StyledBox>
  );
};

PageHeader.defaultProps = {
  spacing: {},
  backAction: undefined,
};

PageHeader.propTypes = {
  header: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  spacing: PropTypes.object,
  backAction: PropTypes.func,
};

export default PageHeader;
